import type { AuthUser, UserRole } from '@/types/common';

export function defaultPathForRole(role: UserRole): string {
  if (role === 'admin') return '/admin/sip';
  if (role === 'team_leader') return '/deals';
  return '/campaigns';
}

export function defaultPathForUser(user: Pick<AuthUser, 'role'>): string {
  return defaultPathForRole(user.role);
}
